import { FC, useEffect, useState } from "react";
import "./Paywall.scss";

interface PaywallPopupProps {
  onUpgrade?: () => void;
  autoHideAfterMs?: number;
}

const PaywallPopup: FC<PaywallPopupProps> = ({
  onUpgrade,
  autoHideAfterMs,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setOpen(true), 300);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!open || !autoHideAfterMs) return;
    const t = setTimeout(() => setOpen(false), autoHideAfterMs);
    return () => clearTimeout(t);
  }, [open, autoHideAfterMs]);

  if (!open) return null;

  return (
    <div aria-live="polite">
      <div
        className="paywall-popup"
        role="dialog"
        aria-label="Upgrade to unlock creators"
      >
        <div className="paywall-icon" aria-hidden>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M3 7l4.5 4L12 5l4.5 6L21 7v11H3V7z" fill="#ffac39" />
          </svg>
        </div>

        <div className="paywall-content">
          <h4 className="paywall-title">Unlock Creator Profiles</h4>
          <p className="paywall-desc">
            Upgrade your plan to see full profiles, contact details, and
            detailed analytics for over 4,000 creators.
          </p>
        </div>

        <div className="paywall-actions">
          <button
            type="button"
            className="paywall-upgrade-btn"
            onClick={() => {
              if (onUpgrade) onUpgrade();
              else window.location.href = "/pricing";
            }}
          >
            Upgrade Now
          </button>

          <button
            type="button"
            className="paywall-later-btn"
            onClick={() => setOpen(false)}
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaywallPopup;
